<div class="notification">
  <div class="notification__message">
    @switch (notification.type) {
      @case ("success") {
        <mat-icon>check_circle</mat-icon>
      }
      @case ("error") {
        <mat-icon>error</mat-icon>
      }
      @case ("info") {
        <mat-icon>info</mat-icon>
      }
    }
    <p [innerHTML]="notification.message | translate: notification.params"></p>
  </div>
  <button mat-button color="primary" (click)="close()">
    {{ "NOTIFICATION.CLOSE" | translate }}
  </button>
</div>
